import { useSelector } from "react-redux";

export default function CourseTypeSelector({ CourseForm, handleFormChange }) {
  const { Course_Offered_List } = useSelector(
    (state) => state.COURSE_OFFERED_LIST_REDUCER
  );

  return (
    <>
      <select
        type="number"
        className="form-control"
        placeholder="Course_Type"
        name={"Course_Type"}
        value={CourseForm.Course_Type}
        onChange={(e) => handleFormChange(e)}>
        <option value="">Select Course Type</option>
        {Course_Offered_List?.map((el, i) => (
          <option key={i + Math.random()} value={el.Id}>
            {el.Study_Level}{" "}
          </option>
        ))}
      </select>
    </>
  );
}
